export default __webpack_public_path__ + "static/media/1.2a60c68f.jpg";